<template>
  <div class="sky-hc-article-list">
    <div class="sky-hc-article-list__head">
      <span class="sky-hc-article-list__head-tit">{{ $t('articleManage.allClass', { num: count }) }}</span>
      <div class="sky-hc-article-list__head-right">
        <span class="sky-hc-article-list__head-num">{{
          $t('articleManage.choosedContent', { num: selection.length })
        }}</span>
        <el-dropdown class="sky-hc-article-list__head-dropdown" trigger="click" :disabled="true">
          <span class="el-dropdown-link el-button el-button--default el-button--mini">
            <i class="el-icon-more"></i>
            <span>{{ $t('articleManage.moreHandler') }}</span>
            <i class="el-icon-arrow-down"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="handleOnline" :disabled="!selectedIdArr.length">
              <el-tooltip :content="$t('fileManage.choose_tip')" placement="right" :disabled="!!selectedIdArr.length">
                <span>{{ $t('articleManage.online') }}</span>
              </el-tooltip>
            </el-dropdown-item>
            <el-dropdown-item @click.native="handleOffine" :disabled="!selectedIdArr.length">
              <el-tooltip :content="$t('fileManage.choose_tip')" placement="right" :disabled="!!selectedIdArr.length">
                <span>{{ $t('articleManage.offline') }}</span>
              </el-tooltip>
            </el-dropdown-item>
            <el-dropdown-item @click.native="handleTop" :disabled="!selectedIdArr.length">
              <el-tooltip :content="$t('fileManage.choose_tip')" placement="right" :disabled="!!selectedIdArr.length">
                <span>{{ $t('articleManage.top') }}</span>
              </el-tooltip>
            </el-dropdown-item>
            <el-dropdown-item @click.native="handleCancelTop" :disabled="!selectedIdArr.length">
              <el-tooltip :content="$t('fileManage.choose_tip')" placement="right" :disabled="!!selectedIdArr.length">
                <span>{{ $t('articleManage.cancelTop') }}</span>
              </el-tooltip>
            </el-dropdown-item>
            <el-dropdown-item @click.native="handleHot" :disabled="!selectedIdArr.length">
              <el-tooltip :content="$t('fileManage.choose_tip')" placement="right" :disabled="!!selectedIdArr.length">
                <span>{{ $t('articleManage.hot') }}</span>
              </el-tooltip>
            </el-dropdown-item>
            <el-dropdown-item @click.native="handleCancelHot" :disabled="!selectedIdArr.length">
              <el-tooltip :content="$t('fileManage.choose_tip')" placement="right" :disabled="!!selectedIdArr.length">
                <span>{{ $t('articleManage.cancelHot') }}</span>
              </el-tooltip>
            </el-dropdown-item>
            <el-dropdown-item @click.native="handleDel" :disabled="!selectedIdArr.length">
              <el-tooltip :content="$t('fileManage.choose_tip')" placement="right" :disabled="!!selectedIdArr.length">
                <span>{{ $t('articleManage.del') }}</span>
              </el-tooltip>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button icon="el-icon-plus" @click.native="gotToCreateArticle">{{
          $t('articleManage.addArticle')
        }}</el-button>
      </div>
    </div>
    <pagination-table
      ref="multipleTable"
      :data="articleList"
      :limit="limit"
      :total="count"
      :hasSearch="true"
      :page="page"
      :searchPlaceholder="$t('articleManage.searchArticlePlaceholder')"
      @search="handleSearchArticle"
      @prevClick="handlePrevClick"
      @nextClick="handleNextClick"
      @sizeChange="handleSizeChange"
      @selectionChange="handleSelectionChange"
      @filterChange="handleFilterChange"
    >
      <template slot="columns">
        <el-table-column type="selection" width="72"> </el-table-column>
        <el-table-column prop="title" width="400" :label="$t('articleManage.articleTitle')" show-overflow-tooltip>
          <div slot-scope="scope" class="sky-hc-article-list__column-item">
            <img
              v-if="scope.row.hot"
              class="sky-hc-article-list__column--hot"
              src="@/assets/images/article/hot.png"
              srcset="@/assets/images/article/hot@2x.png"
            />
            <span class="sky-hc-article-list__column-con">{{ scope.row.title }}</span>
          </div>
        </el-table-column>
        <el-table-column prop="category" :label="$t('articleManage.articleClass')" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.category ? scope.row.category.name : '' }}</template>
        </el-table-column>
        <el-table-column
          prop="publish"
          :label="$t('articleManage.articleStatus')"
          :filters="ARTICLE_STATUS"
          :filterFooter="false"
          width="120"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.publish">{{ $t('articleManage.putOn') }}</span>
            <span v-else>{{ $t('articleManage.putDown') }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" :label="$t('articleManage.createTime')" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.createTime ? date.format(scope.row.createTime, 'yyyy-MM-dd HH:mm:ss') : '' }}
          </template>
        </el-table-column>
        <el-table-column prop="author" :label="$t('articleManage.createUser')" show-overflow-tooltip> </el-table-column>
        <el-table-column :label="$t('articleManage.handler')" width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <span
              class="sky-hc-article-list__table-btn sky-hc-article-list__table--mr18"
              @click="handleEditArticle(scope.row)"
            >
              {{ $t('articleManage.edit') }}
            </span>
            <span class="sky-hc-article-list__table-btn" @click="handleArticleDetail(scope.row)">{{
              $t('articleManage.detail')
            }}</span>
          </template>
        </el-table-column>
      </template>
    </pagination-table>
  </div>
</template>
<script>
import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Select,
  Option,
  Input,
  Table,
  TableColumn,
  pagination,
  Tooltip
} from 'element-ui'
import date from 'element-ui/lib/utils/date'

import { getArticleList, deleteArticle, publishArticle, topArticle, hotArticle } from '@/api/articleManage'
import PaginationTable from '@/components/paginationTable'
import lang from '@/lang'
const ARTICLE_STATUS = [
  { value: true, text: lang.t('articleManage.putOn') },
  { value: false, text: lang.t('articleManage.putDown') }
]

export default {
  name: 'ArticleList',
  components: {
    [Button.name]: Button,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Input.name]: Input,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [pagination.name]: pagination,
    PaginationTable,
    [Tooltip.name]: Tooltip
  },
  data() {
    return {
      date,
      ARTICLE_STATUS,
      keyword: '',
      page: 0,
      limit: 20,
      count: 0,
      articleList: [],
      selection: [],
      FilterExactMatchArr: [],
      treeExactMatchArr: [],
      currentCategoryId: 0
    }
  },
  computed: {
    pageCount() {
      return Math.ceil(this.count / this.limit)
    },
    selectedIdArr() {
      const idArr = []
      this.selection.map(item => {
        idArr.push(item.id)
      })
      return idArr
    }
  },
  created() {
    this.handleGetArticleList()
  },
  methods: {
    handleGetArticleList() {
      getArticleList({
        limit: this.limit,
        page: this.page,
        searchKeyword: this.keyword,
        exactMatchArr: this.FilterExactMatchArr.concat(this.treeExactMatchArr)
      }).then(response => {
        this.articleList = response.data.content.itemArr
        this.count = response.data.content.total
      })
    },
    handleSearchArticle(keyword) {
      this.page = 0
      this.keyword = keyword
      this.handleGetArticleList()
    },
    handleSelectionChange(selection) {
      this.selection = selection
    },
    handlePrevClick() {
      this.page--
      this.handleGetArticleList()
    },
    handleNextClick() {
      this.page++
      this.handleGetArticleList()
    },
    handleSizeChange(num) {
      this.limit = num
      this.page = 0
      this.handleGetArticleList()
    },
    handleFilterChange(filterObject) {
      const FilterExactMatchArr = []
      this.$refs.multipleTable.$refs.paginationTable.columns.map(item => {
        if (item.filterOpened) {
          FilterExactMatchArr.push({
            name: item.property,
            valueArr: item.filteredValue
          })
        }
      })
      this.FilterExactMatchArr = FilterExactMatchArr
      this.page = 0
      this.handleGetArticleList()
    },
    handleOnline() {
      if (!this.selectedIdArr.length) return
      publishArticle({
        idArr: this.selectedIdArr,
        publish: true
      }).then(() => {
        this.handleGetArticleList()
      })
    },
    handleOffine() {
      if (!this.selectedIdArr.length) return
      publishArticle({
        idArr: this.selectedIdArr,
        publish: false
      }).then(() => {
        this.handleGetArticleList()
      })
    },
    handleTop() {
      if (!this.selectedIdArr.length) return
      topArticle({
        idArr: this.selectedIdArr,
        top: true
      }).then(() => {
        this.handleGetArticleList()
      })
    },
    handleCancelTop() {
      if (!this.selectedIdArr.length) return
      topArticle({
        idArr: this.selectedIdArr,
        top: false
      }).then(() => {
        this.handleGetArticleList()
      })
    },
    handleHot() {
      if (!this.selectedIdArr.length) return
      hotArticle({
        idArr: this.selectedIdArr,
        hot: true
      }).then(() => {
        this.handleGetArticleList()
      })
    },
    handleCancelHot() {
      if (!this.selectedIdArr.length) return
      hotArticle({
        idArr: this.selectedIdArr,
        hot: false
      }).then(() => {
        this.handleGetArticleList()
      })
    },
    handleDel() {
      if (!this.selectedIdArr.length) {
        return
      }
      deleteArticle({
        idArr: this.selectedIdArr
      }).then(() => {
        this.handleGetArticleList()
      })
    },
    gotToCreateArticle() {
      this.$router.push({ path: `/web-manage/article-manage/add-article?categoryId=${this.currentCategoryId}` })
    },
    handleEditArticle(item) {
      this.$router.push({
        path: `/web-manage/article-manage/add-article?id=${item.id}&categoryId=${item.category.id}`
      })
    },
    handleArticleDetail(item) {
      if (item.url) {
        window.open(item.url, 'articleDetail')
      }
    },
    handleCategoryChange(item) {
      this.page = 0
      if (item.id) {
        this.treeExactMatchArr = [
          {
            name: 'categoryId',
            valueArr: [item.id]
          }
        ]
      } else {
        this.treeExactMatchArr = []
      }
      this.currentCategoryId = item.id
      this.handleGetArticleList()
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(hc-article-list) {
  min-height: calc(100vh - 148px);
  box-shadow: -2px 4px 4px 0px rgba(0, 0, 0, 0.1);
  flex: 1;
  position: relative;
  z-index: 1;
  padding-left: 30px;
  padding-top: 26px;
  padding-bottom: 20px;
  @include e(head) {
    display: flex;
    justify-content: space-between;
    margin-bottom: 22px;
  }
  @include e(head-tit) {
    font-size: $--font-size-large;
    color: #333333;
    line-height: 24px;
  }
  @include e(head-num) {
    color: $--color-primary;
    line-height: 19px;
    font-size: $--size-base;
    margin-right: 10px;
  }
  @include e(head-dropdown) {
    margin-right: 10px;
  }
  @include e(search-box) {
    display: flex;
  }
  @include e(search-select) {
    width: 129px;
    margin-right: 10px;
  }
  @include e(search-input) {
    width: 186px;
    .el-icon-search {
      height: 32px;
      cursor: pointer;
    }
  }
  @include e(table) {
    margin-top: 20px;
    @include m(mr18) {
      margin-right: 18px;
    }
  }
  @include e(table-btn) {
    color: $--color-primary;
    cursor: pointer;
  }
  @include e(content) {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-top: 20px;
  }
  @include e(column) {
    @include m(hot) {
      width: 24px;
      height: 24px;
      margin-right: 5px;
    }
  }
  @include e(column-item) {
    display: flex;
    align-items: center;
  }
  @include e(column-con) {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: break-all;
  }
}
</style>
